import {
    Campaign,
    CampaignStatus,
    CampaignSystemKind,
} from '../../../models/Outreach/types'
import { PrimaryCampaignDisplayStatus } from '../types/leasingSeason.types'

export function getPrimaryCampaignDisplayStatus(
    campaign: Campaign,
): PrimaryCampaignDisplayStatus {
    if (campaign.status === CampaignStatus.ACTIVE) {
        return 'active'
    }
    if (campaign.status === CampaignStatus.DRAFT && !campaign.setup_complete) {
        return 'needs_setup'
    }
    if (
        campaign.status === CampaignStatus.DRAFT ||
        campaign.status === CampaignStatus.PAUSED
    ) {
        return 'ready_paused'
    }
    return 'needs_setup'
}

export function findPrimaryCampaign(
    campaigns: Campaign[] | undefined,
    kind: CampaignSystemKind,
): Campaign | undefined {
    return campaigns?.find((c) => c.system_kind === kind)
}

export const PRIMARY_CAMPAIGN_STATUS_LABELS: Record<
    PrimaryCampaignDisplayStatus,
    string
> = {
    needs_setup: 'Needs setup',
    ready_paused: 'Ready (paused)',
    active: 'Active',
}
